// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1P4l_","tab":"Tabs_tab__1lGKj","tabActive":"Tabs_tabActive__MYU5z"};